import request from '@/utils/request'

export function routePost (route) {
  return request({
    url: 'route',
    method: 'POST',
    params: {
      route
    }
  })
}
